import Header from '../../../../googleAd/shared/sections/Header'
import Annotation from '../../../../googleAd/shared/sections/FirstView/Annotation'
import { FirstView } from '../../../shared/sections/FirstView'
import VerticalEntryForm from '../../../shared/forms/VerticalEntryForm'
import tiktokConfig from './config'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './TiktokAllRegionFormPage.module.css'
import { AllRegionSpLandingPageProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { CompanyLogoStrip } from '@/components/Common/CompanyLogoStrip'

const TiktokAllRegionFormPage: React.FC<AllRegionSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()

    return(
        <div className={styles.TiktokAllRegionFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <CompanyLogoStrip />
                <div className={styles.formWrap}>
                    <VerticalEntryForm
                        prefectures={prefectures}
                        config={tiktokConfig}
                    />
                    {/* DEV-3480: 新FV画像に「求人数No.1※」が入るため、その根拠となる調査注記を
                        LP下部に置く。instagram_asc・googleAd 12ページと同じコンポーネント
                        （DEV-3366→DEV-3419でそちらに足したのと同じ扱い）。
                        VerticalEntryFormとの間に要素を挟まないこと。VerticalEntryForm.module.cssの
                        `.vertical + p` が外れてfooter手前に29pxの隙間が出る */}
                    <Annotation />
                </div>
            </StepProvider>
        </div>
    )
}

export default TiktokAllRegionFormPage
